export const environment = {
  envName: 'production',
  production: true,
  api: 'api/',
  prefix: '/',
  surfix: '',
  baseUrl: 'https://apteka.datasystem.pl/',
  websocketsUrl: 'wss://dslocate.datasystem.pl/',
  devicesReportsUrl:
    'https://dslocate3.datasystem.pl/statistics/api/v1/devices/report',
  googleAnalyticsId: 'UA-136124841-1',
  hereMapKey: 'tQP63-NtL5d4eLQjNSbZq8CC-lgxWL43T1Wi02GA0JE',
  firebase: {
    // todo usupełnić danymi z projektu
    apiKey: 'AIzaSyDB6D7UNxpprS3oVq2JIx0SJGz2UoTtjOI',
    authDomain: 'pharma-notyfication.firebaseapp.com',
    projectId: 'pharma-notyfication',
    messagingSenderId: '624422340128',
    appId: '1:624422340128:web:a9d88290d93a60531f1e45'
  },
  vapidPublicKey: 'BN8_ToGKw3m6IJysEwlvWuWLANfx5ApNgNiEMI11GQYpo0U3o3GAKtqYXh4i1d9G9_F4Zw1NQFSjtSnmzq8Kng0', // z “Web push certificates”

};
